import { ApplicationService } from '~/services/application.service'

export default defineNuxtPlugin((nuxtApp) => {
    const { $api } = useNuxtApp()
    const { $i18n } = useNuxtApp()
    // const userStore = useUserStore()

    const applicationService = new ApplicationService($api, $i18n)
    nuxtApp.provide('applicationService', applicationService)
})
